import * as React from "react"

function Consegne(props) {
    return (
        <svg
            id="prefix__Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 50 50"
            xmlSpace="preserve"
            {...props}
        >

            <path
                className="prefix__st0"
                d="M32.7 16.8h8.1c.7 0 1.3.3 1.7.9L46 24h1c1.2 0 2 .8 2 2.3v6.9c0 1.1-.9 2.1-2 2.1h-2M15.3 9.6h17.4v25.6H17.3M9.1 35.2H4"
            />
            <path
                className="prefix__st0"
                d="M45 36.3c0 2.3-1.8 4.1-4.1 4.1s-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1S45 34 45 36.3zM17.3 36.3c0 2.3-1.8 4.1-4.1 4.1s-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1zM32.7 35.2h4.1M34.7 25h7.2v-1l-2.1-3.1M.9 21.9h17.4M9.1 15.8h15.4M7.1 15.8H5M13.2 9.6h-2"
            />
        </svg>
    )
}

export default Consegne
